/**
 * Shared design tokens and section styles aligned with HomePage.
 * Use for consistent typography, colors, and spacing across all pages.
 */

export const BRAND = {
  green: '#477C2E',
  greenHover: '#3d6a27',
  brown: '#7a5c1b',
  darkGreen: '#1a3d1a',
};

export const COLORS = {
  subtitle: '#313530',
  heading: '#2D2929',
  body: '#4B4646',
  cream: '#F9F4E8',
  warm: '#FAF9F6',
  divider: '#EEECE1',
};

/** Page banner (hero) - cream background, Caveat + Nunito + Poppins, matches home section style */
export const pageBannerSx = {
  backgroundColor: COLORS.cream,
  py: { xs: 5, md: 7 },
  px: { xs: 2, sm: 3 },
};

/** Subtitle above main heading - Caveat */
export const sectionSubtitleSx = {
  fontFamily: '"Caveat", cursive',
  fontWeight: 700,
  fontSize: { xs: 24, md: 27 },
  lineHeight: '1.25em',
  letterSpacing: 0,
  color: COLORS.subtitle,
  mb: '25px',
};

/** Main section heading - Nunito */
export const sectionHeadingSx = {
  fontFamily: '"Nunito", sans-serif',
  fontWeight: 900,
  fontSize: { xs: 28, md: 40 },
  lineHeight: '1.25em',
  letterSpacing: '0.01em',
  color: COLORS.heading,
  mb: '50px',
  maxWidth: { xs: '100%', md: 640 },
};

/** Smaller section heading (e.g. card title) */
export const cardHeadingSx = {
  fontFamily: '"Nunito", sans-serif',
  fontWeight: 900,
  fontSize: { xs: 18, md: 20 },
  lineHeight: 1.3,
  letterSpacing: '0.01em',
  color: COLORS.heading,
};

/** Body text - Poppins */
export const bodyTextSx = {
  fontFamily: '"Poppins", sans-serif',
  fontWeight: 300,
  fontSize: 14,
  lineHeight: 1.6,
  letterSpacing: '0.04em',
  color: COLORS.body,
};

/** Primary CTA button - matches HomePage "More About Us" */
export const primaryButtonSx = {
  height: 50,
  borderRadius: 28,
  backgroundColor: BRAND.green,
  color: '#FFFFFF',
  fontFamily: '"Poppins", sans-serif',
  fontWeight: 400,
  fontSize: 15,
  lineHeight: '100%',
  letterSpacing: '0.02em',
  '&:hover': { backgroundColor: BRAND.greenHover },
};

/** Section content wrapper padding */
export const sectionPaddingSx = {
  py: { xs: 6, md: 8 },
  px: { xs: 2, sm: 3 },
};

/** Card style - subtle shadow, rounded */
export const cardSx = {
  borderRadius: 2,
  boxShadow: '0 0 17px 0 rgba(0,0,0,0.06)',
  '&:hover': { boxShadow: '0 0 24px 0 rgba(0,0,0,0.1)' },
};
